module.exports = __webpack_public_path__ + "media/packs/static/fonts/circular-std/bold-0b58ca4241eda42cff1f3195ef650db5.woff2";